import { render, staticRenderFns } from "./PageSix.vue?vue&type=template&id=e4da546a&scoped=true&"
import script from "./PageSix.vue?vue&type=script&lang=js&"
export * from "./PageSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4da546a",
  null
  
)

export default component.exports